export const Footer = () => {
  return (
    <div className="flex items-center justify-between px-6 py-3 text-xs text-base-content/50">
      <span>Mat-E Admin · ASM International</span>
      <span className="font-mono flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-success" />
        online · v1.0.0
      </span>
    </div>
  )
}
